export const DEFAULT_FOLDER_COLOR = '#392994';

export const MS_GRAPH_SERVICE_NAME = 'microsoftgraph' as const;
export const DROPBOX_SERVICE_NAME = 'dropbox' as const;
